
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexhQEfVT7IVD29KJuTQrkdDJzVVAALwhKcpYdtJA_45Yx10Meta } from "/var/www/html/src/pages/login/index.vue?macro=true";
import { default as indexvdKnw5G0ZD8k78s8N_45OE0r7bK8y7M7MFy7bjkRP8A7AMeta } from "/var/www/html/src/pages/panel/index.vue?macro=true";
import { default as indexX_vYza3e2R29dTtHuTunm5_hblhH9xCRkbY5m6E0604Meta } from "/var/www/html/src/pages/register/index.vue?macro=true";
import { default as indexp5tRSMHLBHEkacso5SRn_OUZXuVWIDY7XJ00GFzzGO0Meta } from "/var/www/html/src/pages/gantt-test/index.vue?macro=true";
import { default as indexIua93P62OFOhMmHCrJel8wyxmcQZPDZOOIzqUVbXLoUMeta } from "/var/www/html/src/pages/panel/tags/index.vue?macro=true";
import { default as indexaiqU_45rK9OXu_NA4JZV80MFVxVnQYML7w7V_45py48dwn4Meta } from "/var/www/html/src/pages/playground/index.vue?macro=true";
import { default as index_45M7ap9D_LKj4I_451_45RcgUOXBn3SLSsY2bkBjrq5IwsIYMeta } from "/var/www/html/src/pages/panel/labels/index.vue?macro=true";
import { default as indexsPq0Z53_45s_45XSaQGrq8520cL8AbtIS4yPKb6LYW8_45DusMeta } from "/var/www/html/src/pages/panel/points/index.vue?macro=true";
import { default as index12CajMl_453VMWII_45DyQDSADv5AfjZo17qCGBqW9PCPnYMeta } from "/var/www/html/src/pages/login/confirm/index.vue?macro=true";
import { default as indexGnM8wviJRorvPfNCTxkI70MIFOUBJsoOhnVvgujy_IAMeta } from "/var/www/html/src/pages/panel/profile/index.vue?macro=true";
import { default as index8ovTL_XOlFGSoYgt_Fs6s93O1ual1o3wfHDlyF2CpEYMeta } from "/var/www/html/src/pages/panel/graphics/index.vue?macro=true";
import { default as indexn0Ka3WYbe1JEyN8qineAO9LI7DIsMkwLsa7fywBAudMMeta } from "/var/www/html/src/pages/reset-password/index.vue?macro=true";
import { default as indexQxOeC8b78MoxTTxHDJZipztdFIKxG3fbEapt8O_457T_450Meta } from "/var/www/html/src/pages/forgot-password/index.vue?macro=true";
import { default as index_EPNYRHpgm_gymDseIBXg7RH3D9JPR5HGTcUjp2e6gUMeta } from "/var/www/html/src/pages/gantt-pakowanie/index.vue?macro=true";
import { default as indexAx9d4LWuQMTdx4pw4I2Ew_45jpuGFNU4M4mbrklX0bpPcMeta } from "/var/www/html/src/pages/panel/analytics/index.vue?macro=true";
import { default as index82B7HMw6scmnGZh2ei1A1o4OPLIywMhVsowc8okuTKAMeta } from "/var/www/html/src/pages/panel/dashboard/index.vue?macro=true";
import { default as indexJFSjybd0jdmq7ZnCInw2toLViAbjRMQdnEbyhSexwgYMeta } from "/var/www/html/src/pages/panel/dietetics/index.vue?macro=true";
import { default as indexJce3jgjvFwE8UUBCQuGZqBOQD2zCNaJGyz0_4OocTuIMeta } from "/var/www/html/src/pages/panel/purchases/index.vue?macro=true";
import { default as index6d8tyIkJH_45oSY_nJYQkjcTHwHNZdLBWbtrpsJpyapugMeta } from "/var/www/html/src/pages/panel/warehouse/index.vue?macro=true";
import { default as indexGfc9zbUumt9ZU2Oil2cE9cpdOThKL6OGtdDB8LuBSoEMeta } from "/var/www/html/src/pages/panel/complaints/index.vue?macro=true";
import { default as indexTVkMZYm_tQw_HRaq0HLLMDzrcs2IDwki3ohZFyzhfjEMeta } from "/var/www/html/src/pages/panel/diets/list/index.vue?macro=true";
import { default as indexiQpdIaDzTQL8JBn_1tdGiwuhO1dqxUT9zl5kqveihQUMeta } from "/var/www/html/src/pages/panel/diets/menu/index.vue?macro=true";
import { default as indexoiqh9LdCQZf45HxVkufeaCIvZB_P37ek9qFsBX4yOeAMeta } from "/var/www/html/src/pages/panel/monitoring/index.vue?macro=true";
import { default as indexY5cSuyHwwDfRTQLRIM8Lp5vEbVUTh6DXVy2RIa_455T2kMeta } from "/var/www/html/src/pages/register/confirm/index.vue?macro=true";
import { default as indexp3K2L0M7CLU1KImD5GtB0fWpvvez63lyRQfGPOdzNzIMeta } from "/var/www/html/src/pages/panel/addons/list/index.vue?macro=true";
import { default as indexzDiFJB9Tmq_F3cRufuax90rlAaLShwgJQ8pzg9Mi5sQMeta } from "/var/www/html/src/pages/panel/diets/meals/index.vue?macro=true";
import { default as indexO9SnLHeHj9eX5bwCj2j0zVRhIpLoJP9tSqCbbztpKjgMeta } from "/var/www/html/src/pages/panel/price-lists/index.vue?macro=true";
import { default as indexwLR8_45NAFzQZFJ985yn3tNv_45AA6qSpX_451a3FO1iTaOqMMeta } from "/var/www/html/src/pages/email-confirmation/index.vue?macro=true";
import { default as indexiibTgO7t99SEhkMRCRFZw_45unOs_ROkOA7Oxa10ldC9UMeta } from "/var/www/html/src/pages/panel/clients/list/index.vue?macro=true";
import { default as index2MWFuHxqCoXRd6L_MGkXUdwijcEbl5y5gqezLHdLjhQMeta } from "/var/www/html/src/pages/panel/clients/orders/index.vue?macro=true";
import { default as indexWEw621v1E2Z8_45MXlsPfoU27zvsdU_7aRokNg4tayzYUMeta } from "/var/www/html/src/pages/panel/discount-codes/index.vue?macro=true";
import { default as index2pv_xignnIGnzd7Cbyv_45qboXJtPdMZ8Ze54DF3O_45m74Meta } from "/var/www/html/src/pages/panel/employees/list/index.vue?macro=true";
import { default as index6TM_SPw0i1DGbO0KHfOtgI2WbbgmWHlfn5gwtUIcVZYMeta } from "/var/www/html/src/pages/panel/inbound-buffer/index.vue?macro=true";
import { default as indextoEnJ66e2oWmznlH2KuFFI7SImkPMP4fo6QP4jWqAVoMeta } from "/var/www/html/src/pages/panel/recipe-sockets/index.vue?macro=true";
import { default as indexhs8WtX0xHG8hwYEIRMxp4uQ4KSYRcJtY2ZDXzt_UnTIMeta } from "/var/www/html/src/pages/panel/suppliers/list/index.vue?macro=true";
import { default as indexh_45k_I2QOgmw086igB7xmmoVaLEFVelGBZwJX_4JYLP0Meta } from "/var/www/html/src/pages/panel/deliveries/list/index.vue?macro=true";
import { default as indexkPDdUulE91gxEoPKkV3VQPZAgQoyGo_45iJtbbAADl49EMeta } from "/var/www/html/src/pages/panel/diets/allergens/index.vue?macro=true";
import { default as indexAkMzykZO3RJJ1iI1kdwNgfBqH1jkLDtEOLx8PSWQzVEMeta } from "/var/www/html/src/pages/panel/diets/materials/index.vue?macro=true";
import { default as indexos_99V_bJ5aMC0X5BuEKAs0cvgaZ3iFKFUctLyO5Vw4Meta } from "/var/www/html/src/pages/panel/diets/mealpreps/index.vue?macro=true";
import { default as indexzCdO9UgpHGIfj4emkK84FwwjZCrkItzT4bE2ewpTqU8Meta } from "/var/www/html/src/pages/panel/purchase-orders/index.vue?macro=true";
import { default as indexq5_7AFDRHTBC8Qv0r1g3D1bQ6UBQy_vFDOW4XudXmWIMeta } from "/var/www/html/src/pages/panel/clients/opinions/index.vue?macro=true";
import { default as indexNTumaBLrt5PKqjRgRLT5AGcrBArplg1oOt_45p5yuEsQEMeta } from "/var/www/html/src/pages/panel/production-plans/index.vue?macro=true";
import { default as index6TSgkrIKYLX_apzDJJXJqYqkGYNvOds2kwcjn_454DRqQMeta } from "/var/www/html/src/pages/panel/production-units/index.vue?macro=true";
import { default as indexXEEq1S3twWsV1bAQs3kpuuxPTv0TyKHNhvxFQ53uDe8Meta } from "/var/www/html/src/pages/reset-password/confirm/index.vue?macro=true";
import { default as index25ZtU4CP5mFDv63uUoqqpbRmLey1S84dVD3I8XWc0W8Meta } from "/var/www/html/src/pages/panel/addons/categories/index.vue?macro=true";
import { default as indexmv37K5Lxy_45vKmlim6ja2gZd_T4QsKhNAw_FOoQbwV0QMeta } from "/var/www/html/src/pages/panel/production-errors/index.vue?macro=true";
import { default as index3_sl2rhhJ24BEjtj_45W2tojNKK8H1M0_kzjZx_SxOBL8Meta } from "/var/www/html/src/pages/panel/production-orders/index.vue?macro=true";
import { default as index6hXj2OxolT9gLqOcHEQNPh1DlteOMScrcYMXLccS_qMMeta } from "/var/www/html/src/pages/panel/deliveries/centers/index.vue?macro=true";
import { default as indexUfhCgQs9Drdl4EWJPz2WM4FEx3gonNjDJOa5IoUVoeoMeta } from "/var/www/html/src/pages/panel/deliveries/regions/index.vue?macro=true";
import { default as indexCEkr_450a3MMIIUef0c6Gd_oyqQhVh3ens1iC6O9gb6DwMeta } from "/var/www/html/src/pages/panel/employees/couriers/index.vue?macro=true";
import { default as indexqgMd0Z9ezY3N1vQc55uHfpw8GStweskl3Ty2QAgxjBIMeta } from "/var/www/html/src/pages/panel/production-sockets/index.vue?macro=true";
import { default as indexYEIBQaXBjrDgreWj51Rjlndd3mFG7bnWMpBwe5mCuZ8Meta } from "/var/www/html/src/pages/panel/simulation/[...id]/index.vue?macro=true";
import { default as indexKttXlIX7oINwdFclRjbmla13Sd78da_45l0dEv7_PaX4YMeta } from "/var/www/html/src/pages/panel/deliveries/schedule/index.vue?macro=true";
import { default as indexIb4EQ_SqHeOTXgrtcIB5DfJc0ZTlJGKU1YLzwBHMrMMMeta } from "/var/www/html/src/pages/panel/diets/semi-products/index.vue?macro=true";
import { default as index90_458KaOPONg6MZcukg85ZC83TYmP_DTsdB1WYbVtVA4Meta } from "/var/www/html/src/pages/panel/diets/size-matrices/index.vue?macro=true";
import { default as indexs5iQNAPFzlK6R38elmYS4gCEhXT3J8tqQLlhVEFdhzAMeta } from "/var/www/html/src/pages/panel/production-settings/index.vue?macro=true";
import { default as indexHIsL_3NGGZltC1VQYjlnCPcRzzciM2EjosYih68Bf4sMeta } from "/var/www/html/src/pages/panel/tablet/Instructions/index.vue?macro=true";
import { default as indexqTF1fhn4jtRfRxb_45kgUVF5XMkrykjyhU5LygpH_rsEwMeta } from "/var/www/html/src/pages/panel/clients/transactions/index.vue?macro=true";
import { default as indexcAahFKj6134tGDEScaWE78q5h9_RjQJCw7d_jMbspqcMeta } from "/var/www/html/src/pages/panel/deliveries/factories/index.vue?macro=true";
import { default as index1fmKvSE_ZHtTIRWBq0dBjBVBnUdJDsqu1_45GDJ9wwRdQMeta } from "/var/www/html/src/pages/panel/purchases/deliveries/index.vue?macro=true";
import { default as indexG4bXELEXfOg7yXMI3qrVslIdeySG886FYuux2ryJJIsMeta } from "/var/www/html/src/pages/panel/warehouse-deliveries/index.vue?macro=true";
import { default as indexrek1O7VkQjHoLB2_FfLQ8_xoBC4aO5NvmiZKuaXs6CAMeta } from "/var/www/html/src/pages/panel/production-plans/reports/index.vue?macro=true";
import { default as index020zOc_45BPH34HSwHveXoKSlHsYu8CMe4aaTdbtcgM1kMeta } from "/var/www/html/src/pages/panel/production-employees/list/index.vue?macro=true";
import { default as indexT_45a2_45fwcfUL8uBXJf_8i9JKCY6cKA9B02UShVL1TyIAMeta } from "/var/www/html/src/pages/panel/production-plans/[planID]/index.vue?macro=true";
import { default as index6hcOSgI4z8ghru7WD0rmIw5T9SDRqx_45iHf2065ZhhNQMeta } from "/var/www/html/src/pages/panel/production-order-fulfillment/index.vue?macro=true";
export default [
  {
    name: "login",
    path: "/login",
    meta: { ...(indexhQEfVT7IVD29KJuTQrkdDJzVVAALwhKcpYdtJA_45Yx10Meta || {}), ...{"middleware":"no-authorization"} },
    component: () => import("/var/www/html/src/pages/login/index.vue")
  },
  {
    name: "panel",
    path: "/panel",
    meta: indexvdKnw5G0ZD8k78s8N_45OE0r7bK8y7M7MFy7bjkRP8A7AMeta || {},
    component: () => import("/var/www/html/src/pages/panel/index.vue")
  },
  {
    name: "register",
    path: "/register",
    props: {"type":"REGISTER"},
    meta: { ...(indexX_vYza3e2R29dTtHuTunm5_hblhH9xCRkbY5m6E0604Meta || {}), ...{"middleware":"register"} },
    component: () => import("/var/www/html/src/pages/register/index.vue")
  },
  {
    name: "gantt-test",
    path: "/gantt-test",
    component: () => import("/var/www/html/src/pages/gantt-test/index.vue")
  },
  {
    name: "panel-tags",
    path: "/panel/tags",
    meta: indexIua93P62OFOhMmHCrJel8wyxmcQZPDZOOIzqUVbXLoUMeta || {},
    component: () => import("/var/www/html/src/pages/panel/tags/index.vue")
  },
  {
    name: "playground",
    path: "/playground",
    component: () => import("/var/www/html/src/pages/playground/index.vue")
  },
  {
    name: "panel-labels",
    path: "/panel/labels",
    meta: index_45M7ap9D_LKj4I_451_45RcgUOXBn3SLSsY2bkBjrq5IwsIYMeta || {},
    component: () => import("/var/www/html/src/pages/panel/labels/index.vue")
  },
  {
    name: "panel-points",
    path: "/panel/points",
    meta: indexsPq0Z53_45s_45XSaQGrq8520cL8AbtIS4yPKb6LYW8_45DusMeta || {},
    component: () => import("/var/www/html/src/pages/panel/points/index.vue")
  },
  {
    name: "login-confirm",
    path: "/login/confirm",
    meta: index12CajMl_453VMWII_45DyQDSADv5AfjZo17qCGBqW9PCPnYMeta || {},
    component: () => import("/var/www/html/src/pages/login/confirm/index.vue")
  },
  {
    name: "panel-profile",
    path: "/panel/profile",
    meta: indexGnM8wviJRorvPfNCTxkI70MIFOUBJsoOhnVvgujy_IAMeta || {},
    component: () => import("/var/www/html/src/pages/panel/profile/index.vue")
  },
  {
    name: "panel-graphics",
    path: "/panel/graphics",
    meta: index8ovTL_XOlFGSoYgt_Fs6s93O1ual1o3wfHDlyF2CpEYMeta || {},
    component: () => import("/var/www/html/src/pages/panel/graphics/index.vue")
  },
  {
    name: "reset-password",
    path: "/reset-password",
    meta: { ...(indexn0Ka3WYbe1JEyN8qineAO9LI7DIsMkwLsa7fywBAudMMeta || {}), ...{"middleware":"reset-password"} },
    component: () => import("/var/www/html/src/pages/reset-password/index.vue")
  },
  {
    name: "forgot-password",
    path: "/forgot-password",
    meta: indexQxOeC8b78MoxTTxHDJZipztdFIKxG3fbEapt8O_457T_450Meta || {},
    component: () => import("/var/www/html/src/pages/forgot-password/index.vue")
  },
  {
    name: "gantt-pakowanie",
    path: "/gantt-pakowanie",
    component: () => import("/var/www/html/src/pages/gantt-pakowanie/index.vue")
  },
  {
    name: "panel-analytics",
    path: "/panel/analytics",
    meta: indexAx9d4LWuQMTdx4pw4I2Ew_45jpuGFNU4M4mbrklX0bpPcMeta || {},
    component: () => import("/var/www/html/src/pages/panel/analytics/index.vue")
  },
  {
    name: "panel-dashboard",
    path: "/panel/dashboard",
    meta: index82B7HMw6scmnGZh2ei1A1o4OPLIywMhVsowc8okuTKAMeta || {},
    component: () => import("/var/www/html/src/pages/panel/dashboard/index.vue")
  },
  {
    name: "panel-dietetics",
    path: "/panel/dietetics",
    meta: indexJFSjybd0jdmq7ZnCInw2toLViAbjRMQdnEbyhSexwgYMeta || {},
    component: () => import("/var/www/html/src/pages/panel/dietetics/index.vue")
  },
  {
    name: "panel-purchases",
    path: "/panel/purchases",
    meta: indexJce3jgjvFwE8UUBCQuGZqBOQD2zCNaJGyz0_4OocTuIMeta || {},
    component: () => import("/var/www/html/src/pages/panel/purchases/index.vue")
  },
  {
    name: "panel-warehouse",
    path: "/panel/warehouse",
    meta: index6d8tyIkJH_45oSY_nJYQkjcTHwHNZdLBWbtrpsJpyapugMeta || {},
    component: () => import("/var/www/html/src/pages/panel/warehouse/index.vue")
  },
  {
    name: "panel-complaints",
    path: "/panel/complaints",
    meta: indexGfc9zbUumt9ZU2Oil2cE9cpdOThKL6OGtdDB8LuBSoEMeta || {},
    component: () => import("/var/www/html/src/pages/panel/complaints/index.vue")
  },
  {
    name: "panel-diets-list",
    path: "/panel/diets/list",
    meta: indexTVkMZYm_tQw_HRaq0HLLMDzrcs2IDwki3ohZFyzhfjEMeta || {},
    component: () => import("/var/www/html/src/pages/panel/diets/list/index.vue")
  },
  {
    name: "panel-diets-menu",
    path: "/panel/diets/menu",
    meta: indexiQpdIaDzTQL8JBn_1tdGiwuhO1dqxUT9zl5kqveihQUMeta || {},
    component: () => import("/var/www/html/src/pages/panel/diets/menu/index.vue")
  },
  {
    name: "panel-monitoring",
    path: "/panel/monitoring",
    meta: indexoiqh9LdCQZf45HxVkufeaCIvZB_P37ek9qFsBX4yOeAMeta || {},
    component: () => import("/var/www/html/src/pages/panel/monitoring/index.vue")
  },
  {
    name: "register-confirm",
    path: "/register/confirm",
    meta: { ...(indexY5cSuyHwwDfRTQLRIM8Lp5vEbVUTh6DXVy2RIa_455T2kMeta || {}), ...{"middleware":"register-confirm"} },
    component: () => import("/var/www/html/src/pages/register/confirm/index.vue")
  },
  {
    name: "panel-addons-list",
    path: "/panel/addons/list",
    meta: indexp3K2L0M7CLU1KImD5GtB0fWpvvez63lyRQfGPOdzNzIMeta || {},
    component: () => import("/var/www/html/src/pages/panel/addons/list/index.vue")
  },
  {
    name: "panel-diets-meals",
    path: "/panel/diets/meals",
    meta: indexzDiFJB9Tmq_F3cRufuax90rlAaLShwgJQ8pzg9Mi5sQMeta || {},
    component: () => import("/var/www/html/src/pages/panel/diets/meals/index.vue")
  },
  {
    name: "panel-price-lists",
    path: "/panel/price-lists",
    meta: indexO9SnLHeHj9eX5bwCj2j0zVRhIpLoJP9tSqCbbztpKjgMeta || {},
    component: () => import("/var/www/html/src/pages/panel/price-lists/index.vue")
  },
  {
    name: "email-confirmation",
    path: "/email-confirmation",
    meta: indexwLR8_45NAFzQZFJ985yn3tNv_45AA6qSpX_451a3FO1iTaOqMMeta || {},
    component: () => import("/var/www/html/src/pages/email-confirmation/index.vue")
  },
  {
    name: "panel-clients-list",
    path: "/panel/clients/list",
    meta: indexiibTgO7t99SEhkMRCRFZw_45unOs_ROkOA7Oxa10ldC9UMeta || {},
    component: () => import("/var/www/html/src/pages/panel/clients/list/index.vue")
  },
  {
    name: "panel-clients-orders",
    path: "/panel/clients/orders",
    meta: index2MWFuHxqCoXRd6L_MGkXUdwijcEbl5y5gqezLHdLjhQMeta || {},
    component: () => import("/var/www/html/src/pages/panel/clients/orders/index.vue")
  },
  {
    name: "panel-discount-codes",
    path: "/panel/discount-codes",
    meta: indexWEw621v1E2Z8_45MXlsPfoU27zvsdU_7aRokNg4tayzYUMeta || {},
    component: () => import("/var/www/html/src/pages/panel/discount-codes/index.vue")
  },
  {
    name: "panel-employees-list",
    path: "/panel/employees/list",
    meta: index2pv_xignnIGnzd7Cbyv_45qboXJtPdMZ8Ze54DF3O_45m74Meta || {},
    component: () => import("/var/www/html/src/pages/panel/employees/list/index.vue")
  },
  {
    name: "panel-inbound-buffer",
    path: "/panel/inbound-buffer",
    meta: index6TM_SPw0i1DGbO0KHfOtgI2WbbgmWHlfn5gwtUIcVZYMeta || {},
    component: () => import("/var/www/html/src/pages/panel/inbound-buffer/index.vue")
  },
  {
    name: "panel-recipe-sockets",
    path: "/panel/recipe-sockets",
    meta: indextoEnJ66e2oWmznlH2KuFFI7SImkPMP4fo6QP4jWqAVoMeta || {},
    component: () => import("/var/www/html/src/pages/panel/recipe-sockets/index.vue")
  },
  {
    name: "panel-suppliers-list",
    path: "/panel/suppliers/list",
    meta: indexhs8WtX0xHG8hwYEIRMxp4uQ4KSYRcJtY2ZDXzt_UnTIMeta || {},
    component: () => import("/var/www/html/src/pages/panel/suppliers/list/index.vue")
  },
  {
    name: "panel-deliveries-list",
    path: "/panel/deliveries/list",
    meta: indexh_45k_I2QOgmw086igB7xmmoVaLEFVelGBZwJX_4JYLP0Meta || {},
    component: () => import("/var/www/html/src/pages/panel/deliveries/list/index.vue")
  },
  {
    name: "panel-diets-allergens",
    path: "/panel/diets/allergens",
    meta: indexkPDdUulE91gxEoPKkV3VQPZAgQoyGo_45iJtbbAADl49EMeta || {},
    component: () => import("/var/www/html/src/pages/panel/diets/allergens/index.vue")
  },
  {
    name: "panel-diets-materials",
    path: "/panel/diets/materials",
    meta: indexAkMzykZO3RJJ1iI1kdwNgfBqH1jkLDtEOLx8PSWQzVEMeta || {},
    component: () => import("/var/www/html/src/pages/panel/diets/materials/index.vue")
  },
  {
    name: "panel-diets-mealpreps",
    path: "/panel/diets/mealpreps",
    meta: indexos_99V_bJ5aMC0X5BuEKAs0cvgaZ3iFKFUctLyO5Vw4Meta || {},
    component: () => import("/var/www/html/src/pages/panel/diets/mealpreps/index.vue")
  },
  {
    name: "panel-purchase-orders",
    path: "/panel/purchase-orders",
    meta: indexzCdO9UgpHGIfj4emkK84FwwjZCrkItzT4bE2ewpTqU8Meta || {},
    component: () => import("/var/www/html/src/pages/panel/purchase-orders/index.vue")
  },
  {
    name: "panel-clients-opinions",
    path: "/panel/clients/opinions",
    meta: indexq5_7AFDRHTBC8Qv0r1g3D1bQ6UBQy_vFDOW4XudXmWIMeta || {},
    component: () => import("/var/www/html/src/pages/panel/clients/opinions/index.vue")
  },
  {
    name: "panel-production-plans",
    path: "/panel/production-plans",
    meta: indexNTumaBLrt5PKqjRgRLT5AGcrBArplg1oOt_45p5yuEsQEMeta || {},
    component: () => import("/var/www/html/src/pages/panel/production-plans/index.vue")
  },
  {
    name: "panel-production-units",
    path: "/panel/production-units",
    meta: index6TSgkrIKYLX_apzDJJXJqYqkGYNvOds2kwcjn_454DRqQMeta || {},
    component: () => import("/var/www/html/src/pages/panel/production-units/index.vue")
  },
  {
    name: "reset-password-confirm",
    path: "/reset-password/confirm",
    component: () => import("/var/www/html/src/pages/reset-password/confirm/index.vue")
  },
  {
    name: "panel-addons-categories",
    path: "/panel/addons/categories",
    meta: index25ZtU4CP5mFDv63uUoqqpbRmLey1S84dVD3I8XWc0W8Meta || {},
    component: () => import("/var/www/html/src/pages/panel/addons/categories/index.vue")
  },
  {
    name: "panel-production-errors",
    path: "/panel/production-errors",
    meta: indexmv37K5Lxy_45vKmlim6ja2gZd_T4QsKhNAw_FOoQbwV0QMeta || {},
    component: () => import("/var/www/html/src/pages/panel/production-errors/index.vue")
  },
  {
    name: "panel-production-orders",
    path: "/panel/production-orders",
    meta: index3_sl2rhhJ24BEjtj_45W2tojNKK8H1M0_kzjZx_SxOBL8Meta || {},
    component: () => import("/var/www/html/src/pages/panel/production-orders/index.vue")
  },
  {
    name: "panel-deliveries-centers",
    path: "/panel/deliveries/centers",
    meta: index6hXj2OxolT9gLqOcHEQNPh1DlteOMScrcYMXLccS_qMMeta || {},
    component: () => import("/var/www/html/src/pages/panel/deliveries/centers/index.vue")
  },
  {
    name: "panel-deliveries-regions",
    path: "/panel/deliveries/regions",
    meta: indexUfhCgQs9Drdl4EWJPz2WM4FEx3gonNjDJOa5IoUVoeoMeta || {},
    component: () => import("/var/www/html/src/pages/panel/deliveries/regions/index.vue")
  },
  {
    name: "panel-employees-couriers",
    path: "/panel/employees/couriers",
    meta: indexCEkr_450a3MMIIUef0c6Gd_oyqQhVh3ens1iC6O9gb6DwMeta || {},
    component: () => import("/var/www/html/src/pages/panel/employees/couriers/index.vue")
  },
  {
    name: "panel-production-sockets",
    path: "/panel/production-sockets",
    meta: indexqgMd0Z9ezY3N1vQc55uHfpw8GStweskl3Ty2QAgxjBIMeta || {},
    component: () => import("/var/www/html/src/pages/panel/production-sockets/index.vue")
  },
  {
    name: "panel-simulation-id",
    path: "/panel/simulation/:id(.*)*",
    meta: indexYEIBQaXBjrDgreWj51Rjlndd3mFG7bnWMpBwe5mCuZ8Meta || {},
    component: () => import("/var/www/html/src/pages/panel/simulation/[...id]/index.vue")
  },
  {
    name: "panel-deliveries-schedule",
    path: "/panel/deliveries/schedule",
    meta: indexKttXlIX7oINwdFclRjbmla13Sd78da_45l0dEv7_PaX4YMeta || {},
    component: () => import("/var/www/html/src/pages/panel/deliveries/schedule/index.vue")
  },
  {
    name: "panel-diets-semi-products",
    path: "/panel/diets/semi-products",
    meta: indexIb4EQ_SqHeOTXgrtcIB5DfJc0ZTlJGKU1YLzwBHMrMMMeta || {},
    component: () => import("/var/www/html/src/pages/panel/diets/semi-products/index.vue")
  },
  {
    name: "panel-diets-size-matrices",
    path: "/panel/diets/size-matrices",
    meta: index90_458KaOPONg6MZcukg85ZC83TYmP_DTsdB1WYbVtVA4Meta || {},
    component: () => import("/var/www/html/src/pages/panel/diets/size-matrices/index.vue")
  },
  {
    name: "panel-production-settings",
    path: "/panel/production-settings",
    meta: indexs5iQNAPFzlK6R38elmYS4gCEhXT3J8tqQLlhVEFdhzAMeta || {},
    component: () => import("/var/www/html/src/pages/panel/production-settings/index.vue")
  },
  {
    name: "panel-tablet-Instructions",
    path: "/panel/tablet/Instructions",
    meta: indexHIsL_3NGGZltC1VQYjlnCPcRzzciM2EjosYih68Bf4sMeta || {},
    component: () => import("/var/www/html/src/pages/panel/tablet/Instructions/index.vue")
  },
  {
    name: "panel-clients-transactions",
    path: "/panel/clients/transactions",
    meta: indexqTF1fhn4jtRfRxb_45kgUVF5XMkrykjyhU5LygpH_rsEwMeta || {},
    component: () => import("/var/www/html/src/pages/panel/clients/transactions/index.vue")
  },
  {
    name: "panel-deliveries-factories",
    path: "/panel/deliveries/factories",
    meta: indexcAahFKj6134tGDEScaWE78q5h9_RjQJCw7d_jMbspqcMeta || {},
    component: () => import("/var/www/html/src/pages/panel/deliveries/factories/index.vue")
  },
  {
    name: "panel-purchases-deliveries",
    path: "/panel/purchases/deliveries",
    meta: index1fmKvSE_ZHtTIRWBq0dBjBVBnUdJDsqu1_45GDJ9wwRdQMeta || {},
    component: () => import("/var/www/html/src/pages/panel/purchases/deliveries/index.vue")
  },
  {
    name: "panel-warehouse-deliveries",
    path: "/panel/warehouse-deliveries",
    meta: indexG4bXELEXfOg7yXMI3qrVslIdeySG886FYuux2ryJJIsMeta || {},
    component: () => import("/var/www/html/src/pages/panel/warehouse-deliveries/index.vue")
  },
  {
    name: "panel-production-plans-reports",
    path: "/panel/production-plans/reports",
    meta: indexrek1O7VkQjHoLB2_FfLQ8_xoBC4aO5NvmiZKuaXs6CAMeta || {},
    component: () => import("/var/www/html/src/pages/panel/production-plans/reports/index.vue")
  },
  {
    name: "panel-production-employees-list",
    path: "/panel/production-employees/list",
    meta: index020zOc_45BPH34HSwHveXoKSlHsYu8CMe4aaTdbtcgM1kMeta || {},
    component: () => import("/var/www/html/src/pages/panel/production-employees/list/index.vue")
  },
  {
    name: "panel-production-plans-planID",
    path: "/panel/production-plans/:planID()",
    meta: indexT_45a2_45fwcfUL8uBXJf_8i9JKCY6cKA9B02UShVL1TyIAMeta || {},
    component: () => import("/var/www/html/src/pages/panel/production-plans/[planID]/index.vue")
  },
  {
    name: "panel-production-order-fulfillment",
    path: "/panel/production-order-fulfillment",
    meta: index6hcOSgI4z8ghru7WD0rmIw5T9SDRqx_45iHf2065ZhhNQMeta || {},
    component: () => import("/var/www/html/src/pages/panel/production-order-fulfillment/index.vue")
  }
]